import Vue from 'vue'
import Vuex from 'vuex'
import system from './modules/system' // 引入系统选择全局状态管理
import project from './modules/project' // 引入项目立项阶段的项目信息
import loading from './modules/loading' // 全局按钮loading控制
import user from './modules/user' // 当前用户信息
import tagsView from './modules/cachedViews' // 缓存页面
import port from './modules/port'       // 港口信息
import getters from './getters'

Vue.use(Vuex)

const store=new Vuex.Store({
    modules:{
        project,
        loading,
        user,
        tagsView,
        port,
        system
    },
    getters,
    state:{

        //api基础地址s
        // baseUrl:'http://wisdomorg.oicp.net:8189',
        baseUrl:'https://cqtally.co:8082',
        // baseUrl:'http://127.0.0.1:8089', //彭 
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js